// src/components/flexible-search-grid/flexible-search-grid.tsx
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsAnalyticsFlexSearch on FlightsAnalytics {\n    linkName\n    rfrr: referrerId\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsFlexSearchHeaderCell on FlightsFlexibleSearchHeaderCell {\n    labelText\n    valueText\n    headerTheme: theme\n  }\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsFlexSearchLegendCell on FlightsFlexibleSearchLegendCell {\n    accessibilityMessage {\n      usage\n    }\n    icon {\n      description\n      id\n    }\n    valueText\n    legendTheme: theme\n  }\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsNextJourneyCriteriaValues on FlightsNextJourneyCriteriaValues {\n    journeyCriteria {\n      destination\n      departureDate {\n        day\n        month\n        year\n      }\n      origin\n    }\n    searchPreferences {\n      cabinClass\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n  fragment FlightsFlexSearchResults on FlightsFlexibleSearchResultCell {\n    valueText\n    labelText\n    theme\n    summary\n    isLink\n    journeyDate\n    accessibility {\n      highlightDescription\n      selectionDescription\n    }\n    nextSearchCriteria {\n      ...FlightsNextJourneyCriteriaValues\n    }\n    selectAnalytics {\n      ...FlightsAnalyticsFlexSearch\n    }\n  }\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n  fragment DepartureLegendFragment on FlightsFlexibleSearchGridLegendBadge {\n    icon {\n      description\n      id\n    }\n    labelText\n    accessibility\n  }\n"
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n  fragment ResultType on FlightsFlexibleSearchCell {\n    ...FlightsFlexSearchHeaderCell\n    ...FlightsFlexSearchLegendCell\n    ...FlightsFlexSearchResults\n  }\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  fragment Results on FlightsFlexibleSearchResultsGrid {\n    results {\n      __typename\n      ...FlightsFlexSearchHeaderCell\n      ...FlightsFlexSearchLegendCell\n      ...FlightsFlexSearchResults\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  fragment FlexibleSearchResponse on FlightsFlexibleSearchResponse {\n    titleAccessibility\n    flexGridType\n    dismissGridAccessibility {\n      usage\n    }\n    searchTriggerAction\n    dismiss {\n      description\n    }\n    analytics {\n      priceFillRate\n    }\n    departureLegend {\n      ...DepartureLegendFragment\n    }\n    resultsGrid {\n      ...Results\n    }\n    coverageAnalytics {\n      ...FlightsAnalyticsFlexSearch\n    }\n    coverageNotValidAnalytics {\n      ...FlightsAnalyticsFlexSearch\n    }\n  }\n\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  query FlightsFlexibleSearch(\n    $context: ContextInput!\n    $flightsSearchContext: FlightsSearchContextInput\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $queryState: FlightsQueryState\n    $searchPreferences: FlightsSearchPreferencesInput\n    $travelerDetails: [FlightsTravelerDetailsInput!]\n  ) {\n    flightsSearch(\n      context: $context\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      queryState: $queryState\n      searchPreferences: $searchPreferences\n      travelerDetails: $travelerDetails\n    ) {\n      flexibleSearchResponse {\n        ...FlexibleSearchResponse\n      }\n    }\n  }\n\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _tagged_template_literal([
        "\n  fragment FlexibleSearchWrapperFragment on FlightsFlexibleSearchResponse {\n    title\n    subTitle\n  }\n"
    ]);
    _templateObject10 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject11() {
    var data = _tagged_template_literal([
        "\n  query FlightsFlexibleSearchWrapper(\n    $context: ContextInput!\n    $flightsSearchContext: FlightsSearchContextInput\n    $journeyCriteria: [FlightsJourneyCriteriaInput!]!\n    $queryState: FlightsQueryState\n    $searchPreferences: FlightsSearchPreferencesInput\n    $travelerDetails: [FlightsTravelerDetailsInput!]\n  ) {\n    flightsSearch(\n      context: $context\n      flightsSearchContext: $flightsSearchContext\n      journeyCriteria: $journeyCriteria\n      queryState: $queryState\n      searchPreferences: $searchPreferences\n      travelerDetails: $travelerDetails\n    ) {\n      flexibleSearchResponse {\n        ...FlexibleSearchWrapperFragment\n      }\n    }\n  }\n  ",
        "\n"
    ]);
    _templateObject11 = function _templateObject() {
        return data;
    };
    return data;
}
import React5 from "react";
import { gql as gql8, useQuery as useQuery2 } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/flexible-search-grid/__private/__fragments/loading/flexible-search-wrapper.tsx
import React4 from "react";
import { gql as gql7 } from "@apollo/client";
import { useDialog } from "@shared-ui/dialog-context";
import { ViewLarge, Viewport, ViewSmall } from "@shared-ui/viewport-context";
import { UitkCard, UitkCardContentSection, UitkCardLink } from "uitk-react-cards";
import { UitkIcon, UitkIconSize } from "uitk-react-icons";
import { UitkLayoutFlex as UitkLayoutFlex2, UitkLayoutFlexItem as UitkLayoutFlexItem2 } from "uitk-react-layout-flex";
import { UitkSheetTransition } from "uitk-react-sheet";
import { UitkSpacing as UitkSpacing2 } from "uitk-react-spacing";
import { UitkText } from "uitk-react-text";
// src/components/flexible-search-with-results/flexible-search-results.tsx
import React3 from "react";
import { gql as gql6, useQuery } from "@apollo/client";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
import { UitkDateRangeGrid as UitkDateRangeGrid2 } from "uitk-react-date-range-grid";
var _departureLegend_labelText;
// src/components/flexible-search-with-results/utils/get-departure-legend.ts
var getDepartureLegend = function(departureLegend) {
    var _departureLegend_icon, _departureLegend;
    return ((_departureLegend = departureLegend) === null || _departureLegend === void 0 ? void 0 : (_departureLegend_icon = _departureLegend.icon) === null || _departureLegend_icon === void 0 ? void 0 : _departureLegend_icon.id) ? {
        icon: {
            description: departureLegend.icon.description,
            id: departureLegend.icon.id
        },
        labelText: (_departureLegend_labelText = departureLegend.labelText) !== null && _departureLegend_labelText !== void 0 ? _departureLegend_labelText : void 0
    } : {};
};
// src/components/flexible-search-with-results/utils/get-return-legend.ts
var isValidFlightsFlexibleSearchLegendCell = function(result) {
    return result.__typename === "FlightsFlexibleSearchLegendCell";
};
var _grid_reduce_filter_map_find;
var getReturnLegend = function(grid) {
    var _grid;
    return (_grid_reduce_filter_map_find = (_grid = grid) === null || _grid === void 0 ? void 0 : _grid.reduce(function(a, n) {
        return a.concat(n);
    }, []).filter(isValidFlightsFlexibleSearchLegendCell).map(function(result) {
        var _result_icon;
        var _result_valueText;
        return ((_result_icon = result.icon) === null || _result_icon === void 0 ? void 0 : _result_icon.id) ? {
            icon: {
                description: result.icon.description,
                id: result.icon.id
            },
            labelText: (_result_valueText = result.valueText) !== null && _result_valueText !== void 0 ? _result_valueText : void 0
        } : {};
    }).find(Boolean)) !== null && _grid_reduce_filter_map_find !== void 0 ? _grid_reduce_filter_map_find : {};
};
// src/components/flexible-search-with-results/utils/get-initial-searched-cell.ts
var isValidFlightsFlexibleSearchResultCell = function(result) {
    return result.__typename === "FlightsFlexibleSearchResultCell";
};
var _grid_reduce_filter_map_find1;
var getInitialSearchedCell = function(grid) {
    return (_grid_reduce_filter_map_find1 = grid.reduce(function(a, n) {
        return a.concat(n);
    }, []).filter(isValidFlightsFlexibleSearchResultCell).map(function(result) {
        return result.theme === "SEARCHED_DATE" /* SEARCHED_DATE */  || result.theme === "SEARCHED_DATE_LOWEST_PRICE" /* SEARCHED_DATE_LOWEST_PRICE */  || result.theme === "SEARCHED_DATE_UNAVAILABLE_FLIGHTS" /* SEARCHED_DATE_UNAVAILABLE_FLIGHTS */  || result.theme === "SEARCHED_DATE_NO_PRICE" /* SEARCHED_DATE_NO_PRICE */  ? result : void 0;
    }).find(Boolean)) !== null && _grid_reduce_filter_map_find1 !== void 0 ? _grid_reduce_filter_map_find1 : void 0;
};
var _obj;
// src/components/flexible-search-with-results/utils/parse-data-uitk-date-range-format.ts
var themeMapper = (_obj = {}, _define_property(_obj, "DEFAULT" /* DEFAULT */ , "default" /* DEFAULT */ ), _define_property(_obj, "SEARCHED_DATE_HEADER" /* SEARCHED_DATE_HEADER */ , "selected-header" /* SELECTED_HEADER */ ), _define_property(_obj, "HIGHEST_PRICE" /* HIGHEST_PRICE */ , "negative" /* NEGATIVE */ ), _define_property(_obj, "DEFAULT_PRICE" /* DEFAULT_PRICE */ , "default" /* DEFAULT */ ), _define_property(_obj, "LOWEST_PRICE" /* LOWEST_PRICE */ , "positive" /* POSITIVE */ ), _define_property(_obj, "NO_PRICE" /* NO_PRICE */ , "link" /* LINK */ ), _define_property(_obj, "SEARCHED_DATE" /* SEARCHED_DATE */ , "selected-cell" /* SELECTED_CELL */ ), _define_property(_obj, "SEARCHED_DATE_LOWEST_PRICE" /* SEARCHED_DATE_LOWEST_PRICE */ , "selected-cell" /* SELECTED_CELL */ ), _define_property(_obj, "SEARCHED_DATE_NO_PRICE" /* SEARCHED_DATE_NO_PRICE */ , "selected-cell" /* SELECTED_CELL */ ), _define_property(_obj, "SEARCHED_DATE_UNAVAILABLE_FLIGHTS" /* SEARCHED_DATE_UNAVAILABLE_FLIGHTS */ , "selected-cell" /* SELECTED_CELL */ ), _define_property(_obj, "UNAVAILABLE_FLIGHTS" /* UNAVAILABLE_FLIGHTS */ , "unavailable" /* UNAVAILABLE */ ), _obj);
var _results_map;
var parseDataToUitkDateRangeFormat = function(onClickCallBack, clickTracker, isMobile, results) {
    var _results;
    return (_results_map = (_results = results) === null || _results === void 0 ? void 0 : _results.map(function(resultRow) {
        return resultRow.map(function(result) {
            switch(result.__typename){
                case "FlightsFlexibleSearchResultCell":
                    {
                        var _accessibility;
                        var nextSearchCriteria = result.nextSearchCriteria, selectAnalytics = result.selectAnalytics, theme = result.theme, accessibility = result.accessibility, isLink = result.isLink;
                        var callBack = function() {
                            return isMobile ? onClickCallBack(result) : onClickCallBack(nextSearchCriteria !== null && nextSearchCriteria !== void 0 ? nextSearchCriteria : void 0);
                        };
                        var analytics = {
                            id: selectAnalytics.rfrr,
                            description: selectAnalytics.linkName,
                            callback: clickTracker
                        };
                        var _result_valueText, _accessibility_highlightDescription;
                        return {
                            analytics: analytics,
                            onClickCallback: callBack,
                            priceText: (_result_valueText = result.valueText) !== null && _result_valueText !== void 0 ? _result_valueText : "",
                            isLink: isLink,
                            theme: themeMapper[theme],
                            accessibilityText: (_accessibility_highlightDescription = (_accessibility = accessibility) === null || _accessibility === void 0 ? void 0 : _accessibility.highlightDescription) !== null && _accessibility_highlightDescription !== void 0 ? _accessibility_highlightDescription : ""
                        };
                    }
                case "FlightsFlexibleSearchHeaderCell":
                    {
                        var valueText = result.valueText, labelText = result.labelText, headerTheme = result.headerTheme;
                        var _themeMapper_headerTheme;
                        return {
                            dateText: valueText !== null && valueText !== void 0 ? valueText : "",
                            dayText: labelText !== null && labelText !== void 0 ? labelText : "",
                            headerTheme: (_themeMapper_headerTheme = themeMapper[headerTheme]) !== null && _themeMapper_headerTheme !== void 0 ? _themeMapper_headerTheme : "default"
                        };
                    }
                default:
                    return {
                        dateText: "",
                        dayText: "",
                        headerTheme: "default"
                    };
            }
        });
    })) !== null && _results_map !== void 0 ? _results_map : [];
};
// src/components/flexible-search-with-results/__private/__fragments/analytics/flights-analytics-flex-search.ts
import { gql } from "@apollo/client";
var FlightsAnalyticsFlexSearchFragment = gql(_templateObject());
// src/components/flexible-search-with-results/__private/__fragments/results/flights-flex-search-header-cell.ts
import { gql as gql2 } from "@apollo/client";
var FlightsFlexSearchHeaderCellFragment = gql2(_templateObject1());
// src/components/flexible-search-with-results/__private/__fragments/results/flights-flex-search-legend-cell.ts
import { gql as gql3 } from "@apollo/client";
var FlightsFlexSearchLegendCellFragment = gql3(_templateObject2());
// src/components/flexible-search-with-results/__private/__fragments/results/flights-next-journey-criteria-values.ts
import { gql as gql4 } from "@apollo/client";
var FlightsNextJourneyCriteriaValuesFragment = gql4(_templateObject3());
// src/components/flexible-search-with-results/__private/__fragments/results/flights-flex-search-results-cell.ts
import { gql as gql5 } from "@apollo/client";
var FlightsFlexSearchResultsFragment = gql5(_templateObject4(), FlightsNextJourneyCriteriaValuesFragment, FlightsAnalyticsFlexSearchFragment);
// src/components/flexible-search-with-results/flexible-search-mobile/flexible-search-dialog.tsx
import React2 from "react";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { UitkDateRangeGrid } from "uitk-react-date-range-grid";
import { UitkLayoutPosition } from "uitk-react-layout-position";
import { UitkSheet, UitkSheetContent, UitkSheetFooter } from "uitk-react-sheet";
import { UitkToolbar } from "uitk-react-toolbar";
// src/components/flexible-search-with-results/flexible-search-mobile/flexible-search-footer.tsx
import React from "react";
import { UitkButtonSize, UitkPrimaryButton } from "uitk-react-button";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { UitkPriceLockup, UitkPriceLockupAlign } from "uitk-react-price-lockup";
import { UitkSpacing } from "uitk-react-spacing";
var FlexibleSearchFooter = function(param) {
    var currentSelectedCell = param.currentSelectedCell, onClickSearchCallBack = param.onClickSearchCallBack, searchButtonText = param.searchButtonText;
    var handleApplyFare = React.useCallback(function() {
        var _currentSelectedCell, _onClickSearchCallBack;
        var _currentSelectedCell_nextSearchCriteria;
        (_onClickSearchCallBack = onClickSearchCallBack) === null || _onClickSearchCallBack === void 0 ? void 0 : _onClickSearchCallBack((_currentSelectedCell_nextSearchCriteria = (_currentSelectedCell = currentSelectedCell) === null || _currentSelectedCell === void 0 ? void 0 : _currentSelectedCell.nextSearchCriteria) !== null && _currentSelectedCell_nextSearchCriteria !== void 0 ? _currentSelectedCell_nextSearchCriteria : void 0);
    }, [
        currentSelectedCell,
        onClickSearchCallBack
    ]);
    if (!currentSelectedCell || !currentSelectedCell.valueText) {
        return null;
    }
    var valueText = currentSelectedCell.valueText, journeyDate = currentSelectedCell.journeyDate, accessibility = currentSelectedCell.accessibility, summary = currentSelectedCell.summary;
    var _accessibility_highlightDescription, _accessibility_selectionDescription;
    return /* @__PURE__ */ React.createElement(UitkSpacing, {
        padding: "six"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlex, {
        justifyContent: "space-between"
    }, /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkPriceLockup, {
        align: UitkPriceLockupAlign.LEFT,
        lockupPrice: valueText,
        priceSubtextFirst: journeyDate !== null && journeyDate !== void 0 ? journeyDate : void 0,
        a11yPrice: (_accessibility_highlightDescription = accessibility.highlightDescription) !== null && _accessibility_highlightDescription !== void 0 ? _accessibility_highlightDescription : valueText,
        priceSubtextBold: summary !== null && summary !== void 0 ? summary : void 0
    })), searchButtonText && /* @__PURE__ */ React.createElement(UitkLayoutFlexItem, null, /* @__PURE__ */ React.createElement(UitkPrimaryButton, {
        "aria-label": (_accessibility_selectionDescription = accessibility.selectionDescription) !== null && _accessibility_selectionDescription !== void 0 ? _accessibility_selectionDescription : void 0,
        size: UitkButtonSize.LARGE,
        onClick: handleApplyFare
    }, searchButtonText))));
};
// src/components/flexible-search-with-results/flexible-search-mobile/flexible-search-dialog.tsx
var FlightsFareDialog = function(param) {
    var results = param.results, onClickCellCallBack = param.onClickCellCallBack, titleAccessibility = param.titleAccessibility, departureLegend = param.departureLegend, title = param.title, searchText = param.searchText, closeDialog = param.closeDialog, dismissText = param.dismissText, triggerRef = param.triggerRef;
    var clickTracker = useClickTracker();
    var _React2_useState = _sliced_to_array(React2.useState(), 2), selectedCell = _React2_useState[0], setSelectedCell = _React2_useState[1];
    React2.useEffect(function() {
        setSelectedCell(getInitialSearchedCell(results));
    }, [
        results
    ]);
    var onApplySelectionCellCallBack = React2.useCallback(function(cell) {
        setSelectedCell(cell);
    }, []);
    var returnLegend = getReturnLegend(results);
    var dateRangeGrid = React2.useMemo(function() {
        return /* @__PURE__ */ React2.createElement(UitkDateRangeGrid, {
            a11yTitle: titleAccessibility,
            columnLegend: departureLegend,
            rowLegend: returnLegend,
            results: parseDataToUitkDateRangeFormat(onApplySelectionCellCallBack, clickTracker, true, results),
            "data-stid": "flexible-search-dialog"
        });
    }, [
        clickTracker,
        departureLegend,
        onApplySelectionCellCallBack,
        results,
        returnLegend,
        titleAccessibility
    ]);
    var flexibleSearchFooter = React2.useMemo(function() {
        return /* @__PURE__ */ React2.createElement(FlexibleSearchFooter, {
            currentSelectedCell: selectedCell,
            onClickSearchCallBack: onClickCellCallBack,
            searchButtonText: searchText
        });
    }, [
        onClickCellCallBack,
        searchText,
        selectedCell
    ]);
    return /* @__PURE__ */ React2.createElement(UitkSheet, {
        type: "full",
        isVisible: true,
        returnFocusOnClose: true,
        triggerRef: triggerRef
    }, /* @__PURE__ */ React2.createElement(UitkToolbar, {
        navigationContent: {
            onClick: closeDialog,
            navIconLabel: dismissText,
            navType: "close"
        },
        toolbarTitle: title
    }), /* @__PURE__ */ React2.createElement(UitkSheetContent, {
        padded: false
    }, dateRangeGrid), /* @__PURE__ */ React2.createElement(UitkLayoutPosition, {
        type: "relative",
        position: {
            bottom: "zero"
        }
    }, /* @__PURE__ */ React2.createElement(UitkSheetFooter, null, flexibleSearchFooter)));
};
// src/components/flexible-search-with-results/flexible-search-results.tsx
var departureLegendFragment = gql6(_templateObject5());
var ResultTypeFragment = gql6(_templateObject6(), FlightsFlexSearchHeaderCellFragment, FlightsFlexSearchLegendCellFragment, FlightsFlexSearchResultsFragment);
var ResultsFragment = gql6(_templateObject7(), FlightsFlexSearchHeaderCellFragment, FlightsFlexSearchLegendCellFragment, FlightsFlexSearchResultsFragment);
var FlexibleSearchResponseFragment = gql6(_templateObject8(), departureLegendFragment, ResultsFragment, FlightsAnalyticsFlexSearchFragment);
var __FlexibleSearchQuery = gql6(_templateObject9(), FlightsAnalyticsFlexSearchFragment, FlexibleSearchResponseFragment);
var FlexibleSearchResults = function(props) {
    var _dismiss;
    var inputs = props.inputs, skipSsr = props.skipSsr, title = props.title, onClickCellCallBack = props.onClickCellCallBack, isMobile = props.isMobile, closeDialog = props.closeDialog, triggerRef = props.triggerRef;
    var context = useBexApi().context;
    var clickTracker = useClickTracker2();
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery = useQuery(__FlexibleSearchQuery, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery.data, error = _useQuery.error, loading = _useQuery.loading;
    if (loading) {
        return /* @__PURE__ */ React3.createElement(UitkDateRangeGrid2, {
            "data-stid": "flexible-search-results-grid",
            loading: true,
            a11yTitle: title,
            columnLegend: {},
            rowLegend: {},
            results: []
        });
    }
    if (error || !data || !data.flightsSearch.flexibleSearchResponse) {
        return null;
    }
    var flexibleSearchResponse = data.flightsSearch.flexibleSearchResponse;
    var resultsGrid = flexibleSearchResponse.resultsGrid, departureLegend = flexibleSearchResponse.departureLegend, titleAccessibility = flexibleSearchResponse.titleAccessibility, dismiss = flexibleSearchResponse.dismiss, searchTriggerAction = flexibleSearchResponse.searchTriggerAction;
    var results = resultsGrid.results;
    var returnLegend = getReturnLegend(results);
    var departureHeader = getDepartureLegend(departureLegend);
    return /* @__PURE__ */ React3.createElement(React3.Fragment, null, isMobile && closeDialog ? /* @__PURE__ */ React3.createElement(FlightsFareDialog, {
        results: results,
        onClickCellCallBack: onClickCellCallBack,
        title: title,
        titleAccessibility: titleAccessibility,
        departureLegend: departureHeader,
        searchText: searchTriggerAction,
        dismissText: (_dismiss = dismiss) === null || _dismiss === void 0 ? void 0 : _dismiss.description,
        closeDialog: closeDialog,
        triggerRef: triggerRef
    }) : /* @__PURE__ */ React3.createElement(UitkDateRangeGrid2, {
        a11yTitle: titleAccessibility !== null && titleAccessibility !== void 0 ? titleAccessibility : title,
        columnLegend: departureHeader,
        rowLegend: returnLegend,
        results: parseDataToUitkDateRangeFormat(onClickCellCallBack, clickTracker, false, results)
    }));
};
FlexibleSearchResults.displayName = "sharedui-FlexibleSearchResults";
// src/components/flexible-search-grid/__private/__fragments/loading/flexible-search-wrapper.tsx
var fragment = gql7(_templateObject10());
var FlexibleSearchWrapperComponent = function(param) {
    var data = param.data, isExpando = param.isExpando, inputs = param.inputs, onClickCellCallBack = param.onClickCellCallBack;
    var title = data.title, subTitle = data.subTitle;
    var _React4_useState = _sliced_to_array(React4.useState(false), 2), isVisible = _React4_useState[0], setIsVisible = _React4_useState[1];
    var toggleIsVisible = React4.useCallback(function() {
        return setIsVisible(function(visible) {
            return !visible;
        });
    }, []);
    var _useDialog = _sliced_to_array(useDialog("flexible-search-dialog"), 3), isDialogOpen = _useDialog[0], dialogActions = _useDialog[1], DialogComponent = _useDialog[2];
    var triggerRef = React4.useRef(null);
    var toggleMobileIsVisible = React4.useCallback(function() {
        dialogActions.toggleDialog();
        setIsVisible(!isVisible);
    }, [
        dialogActions,
        isVisible
    ]);
    var flexibleSearchResults = React4.useMemo(function() {
        return /* @__PURE__ */ React4.createElement(FlexibleSearchResults, {
            inputs: inputs,
            title: title,
            skipSsr: true,
            onClickCellCallBack: onClickCellCallBack,
            triggerRef: triggerRef
        });
    }, [
        inputs,
        onClickCellCallBack,
        title
    ]);
    var closeDialog = React4.useCallback(function() {
        dialogActions.closeDialog();
        setIsVisible(false);
    }, [
        dialogActions
    ]);
    var mobileFlexibleSearchResults = React4.useMemo(function() {
        return /* @__PURE__ */ React4.createElement(UitkSheetTransition, {
            isVisible: isDialogOpen
        }, /* @__PURE__ */ React4.createElement(DialogComponent, null, /* @__PURE__ */ React4.createElement(FlexibleSearchResults, {
            inputs: inputs,
            closeDialog: closeDialog,
            isMobile: true,
            title: title,
            skipSsr: true,
            onClickCellCallBack: onClickCellCallBack,
            triggerRef: triggerRef
        })));
    }, [
        DialogComponent,
        closeDialog,
        inputs,
        onClickCellCallBack,
        title
    ]);
    return /* @__PURE__ */ React4.createElement(Viewport, null, /* @__PURE__ */ React4.createElement(ViewSmall, null, /* @__PURE__ */ React4.createElement(UitkCard, {
        overflow: true
    }, /* @__PURE__ */ React4.createElement(UitkCardContentSection, {
        padded: true
    }, /* @__PURE__ */ React4.createElement(UitkCardLink, null, /* @__PURE__ */ React4.createElement("button", {
        type: "button",
        onClick: toggleMobileIsVisible,
        ref: triggerRef
    })), /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, {
        grow: 1
    }, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkText, {
        size: 400,
        weight: "bold",
        theme: "standard"
    }, title), /* @__PURE__ */ React4.createElement(UitkText, {
        size: 300,
        theme: "standard"
    }, subTitle)), subTitle), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, {
        alignSelf: "center",
        grow: 0
    }, /* @__PURE__ */ React4.createElement(UitkCardContentSection, {
        padded: false
    }, isVisible ? /* @__PURE__ */ React4.createElement(UitkIcon, {
        name: "expand_less",
        size: UitkIconSize.SMALL
    }) : /* @__PURE__ */ React4.createElement(UitkIcon, {
        name: "expand_more",
        size: UitkIconSize.SMALL
    }))))), isVisible && /* @__PURE__ */ React4.createElement(React4.Fragment, null, mobileFlexibleSearchResults))), /* @__PURE__ */ React4.createElement(ViewLarge, null, isExpando ? /* @__PURE__ */ React4.createElement(UitkCard, null, /* @__PURE__ */ React4.createElement(UitkCardContentSection, {
        padded: true
    }, /* @__PURE__ */ React4.createElement(UitkCardLink, null, /* @__PURE__ */ React4.createElement("button", {
        type: "button",
        onClick: toggleIsVisible
    })), /* @__PURE__ */ React4.createElement(UitkLayoutFlex2, null, /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, {
        grow: 1
    }, /* @__PURE__ */ React4.createElement("div", null, /* @__PURE__ */ React4.createElement(UitkText, {
        size: 400,
        weight: "bold",
        theme: "standard"
    }, title), /* @__PURE__ */ React4.createElement(UitkText, {
        size: 300,
        theme: "standard"
    }, subTitle))), /* @__PURE__ */ React4.createElement(UitkLayoutFlexItem2, {
        alignSelf: "center",
        grow: 0
    }, /* @__PURE__ */ React4.createElement(UitkCardContentSection, {
        padded: false
    }, isVisible ? /* @__PURE__ */ React4.createElement(UitkIcon, {
        name: "expand_less",
        size: UitkIconSize.SMALL
    }) : /* @__PURE__ */ React4.createElement(UitkIcon, {
        name: "expand_more",
        size: UitkIconSize.SMALL
    }))))), isVisible && /* @__PURE__ */ React4.createElement(UitkCardContentSection, {
        padded: [
            "blockend",
            "inlinestart",
            "inlineend"
        ],
        "data-stid": "flexible-search-content-section"
    }, /* @__PURE__ */ React4.createElement(UitkSpacing2, {
        padding: {
            blockend: "one",
            inline: "one"
        }
    }, /* @__PURE__ */ React4.createElement("div", null, flexibleSearchResults)))) : flexibleSearchResults));
};
FlexibleSearchWrapperComponent.fragment = fragment;
FlexibleSearchWrapperComponent.displayName = "FlexibleSearchWrapper";
// src/components/flexible-search-grid/flexible-search-grid.tsx
var __Query = gql8(_templateObject11(), FlexibleSearchWrapperComponent.fragment);
var FlexibleSearchGrid = function(props) {
    var inputs = props.inputs, skipSsr = props.skipSsr, isExpando = props.isExpando, onClickCellCallBack = props.onClickCellCallBack;
    var context = useBexApi2().context;
    var variables = _object_spread_props(_object_spread({}, inputs), {
        context: context
    });
    var _useQuery2 = useQuery2(__Query, {
        variables: variables,
        ssr: !skipSsr
    }), data = _useQuery2.data, error = _useQuery2.error, loading = _useQuery2.loading;
    if (loading || error || !data || !data.flightsSearch.flexibleSearchResponse) {
        return null;
    }
    return /* @__PURE__ */ React5.createElement(FlexibleSearchWrapperComponent, {
        isExpando: isExpando,
        data: data.flightsSearch.flexibleSearchResponse,
        inputs: inputs,
        onClickCellCallBack: onClickCellCallBack
    });
};
FlexibleSearchGrid.displayName = "sharedui-FlexibleSearchGrid";
export { FlexibleSearchGrid }; /* istanbul ignore next -- @preserve */ 
//# sourceMappingURL=index.js.map